export class BudgetSave {
    id: number;
    code: string;
    name: string;
    companyId: number;
    projectId: number;
    administrationId: number;
    masterTypeId: number;
    typeId: number;
    subTypeId: number;
    employeeId: number;
    accMonthId: number;
    interCompanyId: number;
    partnerId: number;
    accountId: number;
    costCenterId: number;
    valueIni: number;
    valueFin: number;
    quantity: number;
    info: string;
    validated: boolean;
}
